<template>
  <div class="login">
    <div class="login-modal">
      <h1>Доступ запрещен</h1>
      <span>Ваш аккаунт GitLab не обладает достаточными правами для доступа к панели администратора.</span>
    </div>
  </div>
</template>

<script>
export default {};
</script>


<style lang="scss" scoped>
.login {
  display: flex;
  align-items: center;
  justify-content: center;
  height: 100%;

  h1 {
    font-size: 24px;
  }
}

.login-modal {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  width: 370px;
  height: 180px;
  padding: 0 12px;
  background: #fafafa;
  border: 1px solid rgba(0, 0, 0, 0.25);
  border-radius: 4px;
  text-align: center;

  span {
    margin: 8px 0 14px;
  }
}

.gitlab-button {
  padding: 4px 14px;
  background: #3e1d56;
}

.gitlab-logo {
  width: 96px;
  height: 34px;
}
</style>
